import { defineMessages } from '@atlassian/jira-intl';

export default defineMessages({
	tryAcrossProductsSpork: {
		id: 'business-trial-banner.modal.try-across-products-spork',
		defaultMessage: 'Try Premium features for free ',
		description:
			'Modal dialog heading that prompts the user can upgrade their Jira to the Premium Plan',
	},
	startATrialSpork: {
		id: 'business-trial-banner.modal.start-a-trial-spork',
		defaultMessage:
			'Start a <b>30-day trial</b> of Jira Premium to unlock advanced project management features for all your teams.',
		description:
			'Modal content describing what the user gets out of a Jira Premium subscription. with emphasising the 30-day trial',
	},
	maybeLater: {
		id: 'business-trial-banner.modal.maybe-later',
		defaultMessage: 'Maybe later',
		description: 'A button for dismissing a modal to upgrade the current plan of Jira',
	},
	tryPremium: {
		id: 'business-trial-banner.modal.try-premium',
		defaultMessage: 'Try now',
		description: 'A button for upgrading your Jira plan to the Premium plan option',
	},
});
